const NOTIFICATION_POLL_INTERVAL_MS = 90000;
const NOTIFICATION_BACKOFF_MAX_MS = 300000;

let pollTimerId = null;
let backoffUntil = 0;
let subscribers = new Set();
let lastUnreadCount = 0;

const parseRetryAfterMs = (retryAfter) => {
  if (!retryAfter) return 30000;
  const seconds = parseInt(retryAfter, 10);
  if (!Number.isNaN(seconds)) return seconds * 1000;
  const date = Date.parse(retryAfter);
  if (!Number.isNaN(date)) return Math.max(date - Date.now(), 0);
  return 30000;
};

const fetchUnreadCount = async (api) => {
  if (Date.now() < backoffUntil) return lastUnreadCount;

  try {
    const response = await api.get('api/school-common/notification/get-unread-count');
    lastUnreadCount = response?.data ?? 0;
    subscribers.forEach((listener) => listener(lastUnreadCount));
    return lastUnreadCount;
  } catch (error) {
    if (error.response?.status === 429) {
      const retryMs = parseRetryAfterMs(error.response.headers?.['retry-after']);
      backoffUntil = Date.now() + Math.min(retryMs, NOTIFICATION_BACKOFF_MAX_MS);
    }
    return lastUnreadCount;
  }
};

export const subscribeNotificationCount = (listener) => {
  subscribers.add(listener);
  listener(lastUnreadCount);
  return () => subscribers.delete(listener);
};

export const startNotificationPolling = (api, { immediate = true } = {}) => {
  if (immediate) {
    fetchUnreadCount(api);
  }

  if (pollTimerId) return;

  pollTimerId = window.setInterval(() => {
    fetchUnreadCount(api);
  }, NOTIFICATION_POLL_INTERVAL_MS);
};

export const stopNotificationPolling = () => {
  if (pollTimerId) {
    window.clearInterval(pollTimerId);
    pollTimerId = null;
  }
};

export const refreshNotificationCount = (api) => fetchUnreadCount(api);

export const NOTIFICATION_POLL_MS = NOTIFICATION_POLL_INTERVAL_MS;
